// extracted by mini-css-extract-plugin
export default {"container":"ExtendedInfoDownload_container__CuLLV","layout":"ExtendedInfoDownload_layout__N0zWm","button":"ExtendedInfoDownload_button__mc00q"};